import * as core from '../../../../../../../core'
import * as researchType from '../research-type'

export const RESOURCE = {
  payload: {
    description: 'Bench Research',
    enumId: core.dms.models.Enum.Id.from({
      partialId: researchType.RESOURCE.payload.partialId,
    }),
    id: 'BENCH RESEARCH',
    name: 'Bench Research',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
